import { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { findByUsuario } from "./api-aluno-responsavel";
import { changeARAluno } from "../Usuario/api-usuario";
import { setUsuario } from "../Usuario/actions/actions";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import { success } from "../../util/ToastUtil";
import { splitUtil } from "../../util/StringUtil";
import Loading from "../UI/Loading";

export default function AlunoResponsavelAtivo() {
  const usuario = useSelector((state) => state.usuario);
  const dispatch = useDispatch();
  const [alunosResponsavel, setAlunosResponsavel] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const usuarioId = usuario?.id;

  useEffect(() => {
    if (!usuarioId) return;
    let active = true;
    setIsLoading(true);
    findByUsuario(usuarioId)
      .then((data) => {
        if (!active || !data) return;
        if (data.error) {
          errorMessage(data.message);
        } else if (Array.isArray(data)) {
          setAlunosResponsavel(data);
        }
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [usuarioId]);

  const handleAtivar = (aluno) => {
    setIsSaving(true);
    changeARAluno(aluno)
      .then((data) => {
        if (!data) return;
        if (data.error) {
          errorMessage(data.message);
          return;
        }
        dispatch(setUsuario(data));
        success("Aluno selecionado.");
      })
      .finally(() => setIsSaving(false));
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <Box py={5}>
          <Loading size={28} description="Carregando Alunos..." />
        </Box>
      );
    }
    if (alunosResponsavel.length === 0) {
      return (
        <Typography variant="body2" color="text.secondary" textAlign="center" py={5}>
          Nenhum aluno vinculado.
        </Typography>
      );
    }
    return (
      <Box display="grid" gridTemplateColumns="repeat(auto-fill, minmax(150px, 1fr))" gap={2}>
        {alunosResponsavel.map((ar) => {
          const selecionado = usuario?.arAlunoSelecionado?.codigo === ar.aluno.codigo;
          return (
            <Card
              key={ar.codigo}
              variant="outlined"
              sx={{
                p: 2,
                textAlign: "center",
                borderColor: selecionado ? "success.main" : "divider",
                borderWidth: selecionado ? 2 : 1,
              }}
            >
              <Avatar
                src={ar.alunoFoto?.foto}
                alt={ar.aluno.nome}
                sx={{ width: 88, height: 88, mx: "auto", mb: 1.5 }}
              />
              <Typography variant="body2" fontWeight={600} gutterBottom>
                {splitUtil(ar.aluno.nome, " ", 2)}
              </Typography>
              {selecionado ? (
                <Chip size="small" color="success" label="Selecionado" />
              ) : (
                <Button size="small" variant="outlined" disabled={isSaving} onClick={() => handleAtivar(ar.aluno)}>
                  Selecionar
                </Button>
              )}
            </Card>
          );
        })}
      </Box>
    );
  };

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, p: 2.5, height: "100%" }}>
      <Typography variant="subtitle1" fontWeight={600} mb={2}>
        Alunos
      </Typography>
      {renderContent()}
    </Paper>
  );
}
